import apiService from "../services/apiServices";

export async function bulkUpload(payload) {
  const response = await apiService.post(`/api/contacts-bulk-upload/`, payload);
  return response;
}